import { client } from "../../infrastructure/graphql/client";
import { GET_COST_AMOUNTS, INVOICES_GET_ALL } from "../../infrastructure/graphql/invoiceQueries";

export class InvoiceService {
  async getInvoicesBySmartIndex(index = 0) {
    try {
      const result = await client.query({
        query: INVOICES_GET_ALL,
        variables: { index },
        fetchPolicy: "network-only",
      });

      const response = result.data?.invoicesBySmartIndex;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get invoices by smart index error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
  async getCostAmounts(startMonth, startYear, endMonth, endYear) {
    try {
      const result = await client.query({
        query: GET_COST_AMOUNTS,
        variables: { startMonth, startYear, endMonth, endYear },
        fetchPolicy: "network-only",
      });

      const response = result.data?.costAmounts;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get cost amounts error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}